module.exports = __webpack_public_path__ + "img/p05502.9df57568.png";